import { render, staticRenderFns } from "./promotionEffect.vue?vue&type=template&id=2cc0db72&scoped=true"
import script from "./promotionEffect.vue?vue&type=script&lang=js"
export * from "./promotionEffect.vue?vue&type=script&lang=js"
import style0 from "./promotionEffect.vue?vue&type=style&index=0&id=2cc0db72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc0db72",
  null
  
)

export default component.exports